import './overview-stage.scss';

class OverviewStage {
    constructor ($element) {
        this.$overviewStage = $element;
        this.$itemsToMove = this.$overviewStage.querySelectorAll('[data-overview-stage="move"]');
    }

    initialize () {
        const isTouchDevice = 'ontouchstart' in document.documentElement;
        const windowWidth = window.innerWidth;

        if (!isTouchDevice && windowWidth > 1023) {
            if (this.$itemsToMove.length > 0) {
                this.$overviewStage.addEventListener('mousemove', (e) => {
                    this.stageAnimation(e);
                });
            }
        }

        window.resizeHandler.customFunctions.push(() => {
            const newWindowWidth = window.innerWidth;

            if (newWindowWidth < 1024) {
                this.$overviewStage.addEventListener('mousemove', (e) => {
                    for (let i = 0; i < this.$itemsToMove.length; i++) {
                        const $itemToMove = this.$itemsToMove[i];
                        this.setMobileStage($itemToMove);
                    }
                });
            } else {
                this.$overviewStage.addEventListener('mousemove', (e) => {
                    this.stageAnimation(e);
                });
            }
        });
    }

    stageAnimation (e) {
        for (let i = 0; i < this.$itemsToMove.length; i++) {
            const $itemToMove = this.$itemsToMove[i];
            const type = $itemToMove.getAttribute('data-overview-stage-type');
            this.setTransitions(e, $itemToMove, type);
        }
    }

    setTransitions (e, elem, type) {
        const _w = window.innerWidth / 2;
        const _h = window.innerHeight / 2;
        const _mouseX = e.clientX;
        const _mouseY = e.clientY;
        const _depth1Multiplier = 0.01;
        const _depth2Multiplier = 0.02;
        const _depth3Multiplier = 0.06;
        let _depth3MultiplierY = 0.06;

        if (type === 'bg') {
            _depth3MultiplierY = 0.02;
        }
        const _depth1 = `${50 - (_mouseX - _w) * _depth1Multiplier}% ${50 - (_mouseY - _h) * _depth1Multiplier}%`;
        const _depth2 = `${50 - (_mouseX - _w) * _depth2Multiplier}% ${50 - (_mouseY - _h) * _depth2Multiplier}%`;
        const _depth3 = `${50 - (_mouseX - _w) * _depth3Multiplier}% ${50 - (_mouseY - _h) * _depth3MultiplierY}%`;
        const x = `${_depth3}, ${_depth2}, ${_depth1}`;
        elem.style.backgroundPosition = x;
    }

    setMobileStage (elem) {
        elem.style.backgroundPosition = '50% 50%';
    }
}

export { OverviewStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $overviewStages = $context.querySelectorAll('[data-overview-stage="root"]');
        if ($overviewStages.length > 0) {
            $overviewStages.forEach((overviewStage) => {
                const $overviewStage = new OverviewStage(overviewStage);
                $overviewStage.initialize();
            });
        }
    }
});
